import { SquarePenIcon } from 'lucide-react'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { BillsTableRow } from '../../../../types/billsTableRow'
import { BillsTableActionType } from '../../enums/billsTableActionType'
import { BillsTableAction } from '../../types/billsTableAction'

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const useEditBillAction = (row: BillsTableRow): BillsTableAction => {
  const navigate = useNavigate()
  const location = useLocation()
  const { url: editBillUrl } = useOrganizationViewUrl(reactRoute.organization.bills.getEditBillRoute(row.id))

  const navigateToEdit = useCallback(() => {
    if (!editBillUrl) {
      return
    }

    // Preserve the list's search params so the user lands back on the same filtered list
    navigate(`${editBillUrl}${location.search}`)
  }, [editBillUrl, location.search, navigate])

  return {
    type: BillsTableActionType.Edit,
    label: 'Edit',
    icon: SquarePenIcon,
    onClick: navigateToEdit,
  }
}
